module.exports = __webpack_public_path__ + "img/lorna.10961258.jpg";